import React, { useState } from "react";
import "components/client/dashboard/profile/Cards/cards.css";
import "./referral.css";
import "components/rep/settings/subscriptions/cancel/cancel.css";
import { IoGift } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import RepReferrals from "../settings/RepReferrals";
import { useHistory } from "react-router-dom";
interface ReferralsButtonProps {
  fromDrawer?: boolean;
}
const ReferralsButton: React.FC<ReferralsButtonProps> = ({
  fromDrawer = false,
}) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleRelocate = () => {
    setShowModal(false);
    history.push("/rep/rewards");
  };
  return (
    <>
      <button
        className={fromDrawer ? "drawer-nav-link" : "referral-button"}
        onClick={() => setShowModal((prev) => !prev)}
      >
        {fromDrawer ? (
          <>
            <IoGift style={{ width: 20, height: 20, margin: 0 }} />
            <span>Referrals</span>
          </>
        ) : (
          <IoGift />
        )}
      </button>
      <div className={`custom-scroll-sm cr-modal ${showModal ? "open" : ""}`}>
        <button className="mrc-close-btn" onClick={() => setShowModal(false)}>
          <IoClose style={{ color: "#000", fontSize: 20 }} />
        </button>
        <RepReferrals />

        <button
          className="cancel-un-follow-btn"
          style={{ borderRadius: 4, marginTop: 8 }}
          onClick={handleRelocate}
        >
          Rewards
        </button>
      </div>
      {showModal && (
        <div className="mrc-overlay" onClick={() => setShowModal(false)} />
      )}
    </>
  );
};

export default ReferralsButton;
